<template>
	<transition
			appear
			:appear-active-class="$_inpTxta_styleInputTextareaAnimation()">
		<v-row no-gutters>
			<v-col>
				<validation-provider
						:name="'InputTextarea-' + contentKey"
						:rules="getValidationRules(contents[contentKey].rules)"
						v-slot="{ errors }">
					<v-textarea
							v-model="$store.state.input.data[contentKey].answer"
							
							:auto-grow="$_inpTxta_styleTextareaAutoGrow"
							:background-color="$_inpTxta_styleTextareaBackgroundColor"
							:clearable="$_inpTxta_styleTextareaClearable"
							:color="$_inpTxta_styleTextareaColor"
							:counter="$_inpTxta_styleTextareaCounter"
							:dark="$_inpTxta_styleTextareaDark"
							:filled="$_inpTxta_styleTextareaFilled"
							:flat="$_inpTxta_styleTextareaFlat"
							:light="$_inpTxta_styleTextareaLight"
							:outlined="$_inpTxta_styleTextareaOutlined"
							:rows="$_inpTxta_styleTextareaRows"
							:solo="$_inpTxta_styleTextareaSolo"
							:solo-inverted="$_inpTxta_styleTextareaSoloInverted"

							:append-icon="$_inpTxta_styleParamAppendIcon(contents[contentKey].params)"
							:append-outer-icon="$_inpTxta_styleParamAppendOuterIcon(contents[contentKey].params)"
							:prepend-icon="$_inpTxta_styleParamPrependIcon(contents[contentKey].params)"
							:prepend-inner-icon="$_inpTxta_styleParamPrependInnerIcon(contents[contentKey].params)"

							:hint="$_inpTxta_langParamHint(contents[contentKey].params)"
							:message="$_inpTxta_langParamMessage(contents[contentKey].params)"
							:placeholder="$_inpTxta_langParamPlaceholder(contents[contentKey].params)"

							:error-messages="errors" />
				</validation-provider>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputTextarea',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpTxta_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpTxta_langParamMessage() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.message;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpTxta_langParamPlaceholder() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.placeholder;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			// style
			$_inpTxta_styleInputTextarea() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputTextarea')
				}
			},
			$_inpTxta_styleInputTextareaAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpTxta_styleInputTextarea()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpTxta_styleTextarea() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'textarea')
			},
			$_inpTxta_styleTextareaAutoGrow() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.autoGrow)
			},
			$_inpTxta_styleTextareaBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpTxta_styleTextareaClearable() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_inpTxta_styleTextareaColor() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpTxta_styleTextareaCounter() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_inpTxta_styleTextareaDark() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpTxta_styleTextareaFilled() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_inpTxta_styleTextareaFlat() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_inpTxta_styleTextareaLight() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpTxta_styleTextareaOutlined() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_inpTxta_styleTextareaRows() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.rows)
			},
			$_inpTxta_styleTextareaSolo() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_inpTxta_styleTextareaSoloInverted() {
				const self_ = this;
				const style_ = self_.$_inpTxta_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_inpTxta_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpTxta_styleParamAppendOuterIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendOuterIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpTxta_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpTxta_styleParamPrependInnerIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependInnerIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}
	}
</script>

<style scoped>
</style>
